import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { Router } from '@angular/router';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnDestroy, AfterViewInit {
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  @ViewChild(MatSidenavContainer) sidenavContainer: MatSidenavContainer;
  title = 'Nagarajan R';
  socialLinks = [
    {
      name: 'LinkedIn',
      image: 'assets/images/social/linkedin.png',
      link: 'https://www.linkedin.com/in/rnagarajan96/'
    },
    {
      name: 'Twitter',
      image: 'assets/images/social/twitter.png',
      link: 'https://twitter.com/rnagarajan96'
    },
    {
      name: 'Facebook',
      image: 'assets/images/social/facebook.png',
      link: 'https://www.facebook.com/rnagarajan96'
    }
  ];
  menus = [
    {
      name: 'About',
      route: 'about',
      url: 'assets/images/menu/about.png'
    },
    {
      name: 'Experience',
      route: 'experience',
      url: 'assets/images/menu/experience.png'
    },
    {
      name: 'Projects',
      route: 'projects',
      url: 'assets/images/menu/projects.png'
    },
    {
      name: 'Skills',
      route: 'skills',
      url: 'assets/images/menu/skills.png'
    },
    {
      name: 'Education',
      route: 'education',
      url: 'assets/images/menu/education.png'
    },
    {
      name: 'Gallery',
      route: 'gallery',
      url: 'assets/images/menu/gallery.png'
    },
    {
      name: 'Contact',
      route: 'contact',
      url: 'assets/images/menu/contact.png'
    }
  ];
  promptEvent: any;
  empStrtDate = new Date(new Date(2018, (6 - 1)));
  currentDate = new Date();
  constructor(private router: Router, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher) {

    //check client in installable to show button
    window.addEventListener('beforeinstallprompt', event => {
      this.promptEvent = event;
    });

    //hide icon on install success
    window.addEventListener('appinstalled', (evt) => {
      document.location.reload()
    });

    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }
  ngAfterViewInit(): void {
    this.sidenavContainer.scrollable.elementScrolled().subscribe((result) => {
    });

    let routerPath = this.router.url.split('/').pop();
    this.scrollToElement(routerPath);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  // install mobile app 
  installMobileApp(): void {
    this.promptEvent.prompt();
  }

  scrollToElement(target) {
    var ele = document.getElementById(`${target}`);
    ele.scrollIntoView();
  }

}
